import React from 'react'

import LineUsersMultiIcon from 'LuxKit/Icons/line/LineUsersMultiIcon'
import LineTachometerFastIcon from 'LuxKit/Icons/line/LineTachometerFastIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'
import LineArrowGrowthIcon from 'LuxKit/Icons/line/LineArrowGrowthIcon'
import LineLightbulbAltIcon from 'LuxKit/Icons/line/LineLightbulbAltIcon'
import LineMountainRoadIcon from 'LuxKit/Icons/line/LineMountainRoadIcon'

const missionAndValuesItems = [
  {
    title: 'Think like our customer',
    text: [
      'Understand what our customers',
      'Want (before they do)',
    ],
    icon: <LineUsersMultiIcon size={68} colour="primary" />,
  },
  {
    title: 'Act like a startup',
    text: [
      'Be agile, take risks, kill bureaucracy',
      'Everyone can act like a founder',
    ],
    icon: <LineTachometerFastIcon size={68} colour="primary" />,
  },
  {
    title: 'Extra effort is recognised and rewarded',
    text: [
      'Call out outstanding effort and achievement',
      'Give praise',
    ],
    icon: <LineStarIcon size={68} colour="primary" />,
  },
  {
    title: 'Help others succeed',
    text: [
      'Helping someone else to succeed is the best form of success',
    ],
    icon: <LineArrowGrowthIcon size={68} colour="primary" />,
  },
  {
    title: 'Focus on the solution, learn from your mistakes',
    text: [
      "Don't be afraid of making mistakes - just make sure to learn from them",
      'Understand the problem, but deliver the solution',
    ],
    icon: <LineLightbulbAltIcon size={68} colour="primary" />,
  },
  {
    title: 'Do the hard things',
    text: [
      'The best businesses are great at doing hard things',
    ],
    icon: <LineMountainRoadIcon size={68} colour="primary" />,
  },
]

export default missionAndValuesItems
